var render = function render(){var _vm=this,_c=_vm._self._c;return _c('GroundStationStatusIcon',{attrs:{"icon":_vm.buttonIcon,"tone":_vm.buttonTone,"title":_vm.$t(_vm.buttonTitle),"loading":_vm.voiceListening,"active":_vm.voiceControlEnabled,"interactive":""},on:{"click":_vm.toggleVoiceControl}})
}
var staticRenderFns = []

export { render, staticRenderFns }